import React, { useState } from 'react';
import axios from '../config/axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box,
  CircularProgress,
  Stepper,
  Step,
  StepLabel
} from '@mui/material';
import { useTheme } from '../context/ThemeContext';

const steps = [
  'Enviar Email',      // Paso 0: Enviar email con tracking
  'Confirmar Lectura'  // Paso 1: Verificar que el cliente leyó el email
];

function IntegrityDialog({ open, contractId, onClose }) {
  const { themeColors } = useTheme();
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [emailSent, setEmailSent] = useState(false);

  // Enviar email con tracking
  const handleSendEmail = async () => {
    try {
      setLoading(true);
      setError(null);

      await axios.post(`/api/contracts/${contractId}/integrity/send-email`);
      setEmailSent(true);
      setCurrentStep(1);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al enviar el email');
    } finally {
      setLoading(false);
    }
  };

  // Verificar lectura del email
  const handleCheckEmailRead = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`/api/contracts/${contractId}/integrity/check-read`);
      
      if (response.data.read) {
        await axios.post(`/api/contracts/${contractId}/integrity/confirm-read`);
        onClose(true);
      } else {
        setError('El cliente aún no ha leído el email');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error al verificar lectura');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>
        Proceso de Integridad
        <Stepper activeStep={currentStep} sx={{ mt: 2 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </DialogTitle>

      <DialogContent>
        {error && (
          <Typography color="error" gutterBottom align="center">
            {error}
          </Typography>
        )}

        {loading ? (
          <Box textAlign="center" my={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Box textAlign="center" my={4}>
            {currentStep === 0 && (
              <>
                <Typography gutterBottom>
                  Se enviará un email al cliente para confirmar la integridad del contrato
                </Typography>
                <Button
                  variant="contained"
                  onClick={handleSendEmail}
                  sx={{ 
                    backgroundColor: themeColors.primary,
                    '&:hover': { backgroundColor: themeColors.secondary }
                  }}
                >
                  Enviar Email
                </Button>
              </>
            )}

            {currentStep === 1 && (
              <>
                <Typography gutterBottom>
                  Verificar si el cliente ha leído el email
                </Typography>
                <Button
                  variant="contained"
                  onClick={handleCheckEmailRead}
                  sx={{ 
                    backgroundColor: themeColors.primary,
                    '&:hover': { backgroundColor: themeColors.secondary }
                  }}
                >
                  Verificar Lectura
                </Button>
              </>
            )}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default IntegrityDialog; 